import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useFloatHubStore = defineStore('floatHub', () => {
  const hubPosition = ref({ x: 0, y: 0 })
  const isOpen = ref(false)
  const activeModule = ref(null) // 'chat' | 'knowledge' | null

  const loadHubPosition = () => {
    try {
      const saved = localStorage.getItem('floatHubPosition')
      if (saved) {
        hubPosition.value = JSON.parse(saved)
      } else if (typeof window !== 'undefined') {
        hubPosition.value = {
          x: window.innerWidth - 72,
          y: window.innerHeight - 72
        }
      }
    } catch {
      if (typeof window !== 'undefined') {
        hubPosition.value = {
          x: window.innerWidth - 72,
          y: window.innerHeight - 72
        }
      }
    }
  }

  const saveHubPosition = () => {
    localStorage.setItem('floatHubPosition', JSON.stringify(hubPosition.value))
  }

  const setHubPosition = (pos) => {
    hubPosition.value = pos
    saveHubPosition()
  }

  const toggleOpen = () => {
    isOpen.value = !isOpen.value
    if (!isOpen.value) {
      activeModule.value = null
    }
  }

  const openModule = (moduleName) => {
    activeModule.value = moduleName
    isOpen.value = false
  }

  const closeModule = () => {
    activeModule.value = null
  }

  const closeAll = () => {
    isOpen.value = false
    activeModule.value = null
  }

  return {
    hubPosition,
    isOpen,
    activeModule,
    loadHubPosition,
    saveHubPosition,
    setHubPosition,
    toggleOpen,
    openModule,
    closeModule,
    closeAll
  }
})
